import type { Area } from 'react-easy-crop';

export type ImageCropKind = 'wallpaper' | 'avatar';

export function readCropImage(file: File, kind: ImageCropKind): Promise<string> {
  const allowed = ['image/png', 'image/jpeg', 'image/webp', ...(kind === 'avatar' ? ['image/gif'] : [])];
  if (!allowed.includes(file.type)) return Promise.reject(new Error('请选择 PNG、JPEG 或 WebP 图片' + (kind === 'avatar' ? '，也支持 GIF' : '')));
  if (file.size > 12 * 1024 * 1024) return Promise.reject(new Error('图片不能超过 12 MB'));
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => typeof reader.result === 'string'
      ? resolve(reader.result)
      : reject(new Error('读取图片失败'));
    reader.onerror = () => reject(new Error('读取图片失败'));
    reader.readAsDataURL(file);
  });
}

export async function exportImageCrop(source: string, area: Area, kind: ImageCropKind): Promise<string> {
  if (![area.x, area.y, area.width, area.height].every(Number.isFinite) || area.width <= 0 || area.height <= 0) {
    throw new Error('请重新选择裁剪区域');
  }
  const image = await new Promise<HTMLImageElement>((resolve, reject) => {
    const result = new Image();
    result.onload = () => resolve(result);
    result.onerror = () => reject(new Error('无法解析图片'));
    result.src = source;
  });
  const maxEdge = kind === 'avatar' ? 512 : 1600;
  const scale = Math.min(1, maxEdge / Math.max(area.width, area.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(area.width * scale));
  canvas.height = kind === 'avatar' ? canvas.width : Math.max(1, Math.round(area.height * scale));
  const context = canvas.getContext('2d');
  if (context === null) throw new Error('当前浏览器无法处理图片');
  if (kind === 'avatar') {
    context.beginPath();
    context.arc(canvas.width / 2, canvas.height / 2, canvas.width / 2, 0, Math.PI * 2);
    context.clip();
  }
  context.drawImage(image, area.x, area.y, area.width, area.height, 0, 0, canvas.width, canvas.height);
  return kind === 'avatar' ? canvas.toDataURL('image/png') : canvas.toDataURL('image/jpeg', 0.82);
}
